import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';

import { Role } from '@reg/shared/model';
import { TeamUserService } from '@reg/shared/service';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';

/**
 * This guard is meant to be used for routes that require a team login (/:role-id/:team-id routes).
 */
@Injectable()
export class TeamInviteAuthGuard extends AuthGuard {
    constructor(
protected authService: AuthService,
                protected router: Router,
                private teamUserService: TeamUserService,
    ) {
        super(authService, router);
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (super.canActivate(route, state)) {
            const roleId: string = route.params['role-id'];

            if (roleId === Role.INVITED_COACH) {
                const eventId: string = route.parent.params['event-id'];
                const teamId: string = route.params['team-id'];

                return this.teamUserService.isAuthenticated(eventId, teamId).pipe(map(
                    (loginSuccess: boolean) => {
                        if (!loginSuccess) {
                            this.router.navigate(['error', 'access-denied']);
                        }

                        return loginSuccess;
                    },
                ));
            }
            return true;
        }
    }
}
